export default __webpack_public_path__ + "static/media/star.961a9baa.svg";